var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "authentication-editor" }, [
    _c("label", [_vm._v(_vm._s(_vm.$t("whatsapp_business_api.authSettings")))]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "auth-setting-row" },
      [
        _c(
          "a-checkbox",
          {
            attrs: { checked: _vm.data.addSecurityRecommendation },
            on: { change: _vm.updateSecurity },
          },
          [
            _vm._v(
              "\n            " +
                _vm._s(
                  _vm.$t("whatsapp_business_api.addSecurityRecommendation")
                ) +
                "\n        "
            ),
          ]
        ),
        _vm._v(" "),
        _c("span", { staticClass: "hint-text" }, [
          _vm._v(
            "\n            " +
              _vm._s(
                _vm.$t("whatsapp_business_api.securityRecommendationHint")
              ) +
              "\n        "
          ),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "auth-setting-row",
        staticStyle: { "margin-top": "16px" },
      },
      [
        _c("label", [
          _vm._v(
            _vm._s(_vm.$t("whatsapp_business_api.messageTtlSecondsOptional"))
          ),
        ]),
        _vm._v(" "),
        _c("a-input-number", {
          staticStyle: { width: "100%" },
          attrs: {
            value: _vm.data.messageSendTtlSeconds,
            min: 60,
            max: 600,
            placeholder: _vm.$t("whatsapp_business_api.authTtlPlaceholder"),
          },
          on: { change: _vm.updateTtl },
        }),
        _vm._v(" "),
        _c("span", { staticClass: "hint-text" }, [
          _vm._v(
            "\n            " +
              _vm._s(_vm.$t("whatsapp_business_api.authMessageTtlHint")) +
              "\n        "
          ),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "auth-setting-row",
        staticStyle: { "margin-top": "16px" },
      },
      [
        _c("label", [
          _vm._v(
            _vm._s(_vm.$t("whatsapp_business_api.codeExpirationOptional"))
          ),
        ]),
        _vm._v(" "),
        _c("a-input-number", {
          staticStyle: { width: "100%" },
          attrs: {
            value: _vm.data.codeExpirationMinutes,
            min: 1,
            max: 90,
            placeholder: _vm.$t("whatsapp_business_api.authCodeExpPlaceholder"),
          },
          on: { change: _vm.updateExpiration },
        }),
        _vm._v(" "),
        _c("span", { staticClass: "hint-text" }, [
          _vm._v(
            "\n            " +
              _vm._s(_vm.$t("whatsapp_business_api.codeExpirationHint")) +
              "\n        "
          ),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _vm.data.otpSubType === "ZERO_TAP"
      ? _c(
          "div",
          {
            staticClass: "auth-setting-row",
            staticStyle: {
              "margin-top": "16px",
              "padding-top": "16px",
              "border-top": "1px solid #e8e8e8",
            },
          },
          [
            _c(
              "a-checkbox",
              {
                attrs: { checked: _vm.data.zeroTapTermsAccepted },
                on: { change: _vm.updateTerms },
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("whatsapp_business_api.zeroTapTerms")) +
                    "\n        "
                ),
              ]
            ),
            _vm._v(" "),
            _c("span", { staticClass: "hint-text" }, [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$t("whatsapp_business_api.zeroTapTermsHint")) +
                  "\n        "
              ),
            ]),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.data.otpSubType !== "COPY_CODE"
      ? _c(
          "div",
          {
            staticClass: "auth-setting-row",
            staticStyle: { "margin-top": "16px" },
          },
          [
            _c("label", [
              _vm._v(
                _vm._s(
                  _vm.$t("whatsapp_business_api.supportedAndroidAppsOptional")
                )
              ),
            ]),
            _vm._v(" "),
            _vm._l(_vm.data.supportedApps, function (app, index) {
              return _c(
                "div",
                { key: index, staticClass: "supported-app-row" },
                [
                  _c("a-input", {
                    staticStyle: { flex: "1" },
                    attrs: {
                      value: app.packageName,
                      placeholder: _vm.$t(
                        "whatsapp_business_api.authPackagePlaceholder"
                      ),
                    },
                    on: {
                      input: function ($event) {
                        return _vm.updateAppPackage(index, $event.target.value)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("a-input", {
                    staticStyle: { flex: "1" },
                    attrs: {
                      value: app.signatureHash,
                      placeholder: _vm.$t(
                        "whatsapp_business_api.authSignatureHash"
                      ),
                    },
                    on: {
                      input: function ($event) {
                        return _vm.updateAppSignature(
                          index,
                          $event.target.value
                        )
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "a-button",
                    {
                      attrs: { type: "link" },
                      on: {
                        click: function ($event) {
                          return _vm.removeApp(index)
                        },
                      },
                    },
                    [_c("a-icon", { attrs: { type: "delete" } })],
                    1
                  ),
                ],
                1
              )
            }),
            _vm._v(" "),
            _c(
              "a-button",
              {
                staticStyle: { "margin-top": "8px" },
                attrs: { size: "small" },
                on: { click: _vm.addApp },
              },
              [
                _c("a-icon", { attrs: { type: "plus" } }),
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("whatsapp_business_api.addApp")) +
                    "\n        "
                ),
              ],
              1
            ),
          ],
          2
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }